import { DATE_FORMAT_API } from '@/constants/dateTimeFormats';
import moment from 'moment';

export const reports6kTests = {
    namespaced: true,

    state: {
        filter: {
            start_date: moment().subtract(1, 'months').format(DATE_FORMAT_API),
            end_date: moment().format(DATE_FORMAT_API),
            athletes: [],
            squads: [],
            gender: '',
            site: '',
            ergo: '',
            date_of_birth: '',
            first_name: '',
            last_name: '',
            sweep_scull: '',
            weight_class: '',
            weight: null,
            height: null,
            tags: [],
            focuses: []
        }
    },

    getters: {
        k6TestFilter(state) {
            return state.filter;
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                start_date: moment().subtract(1, 'months').format(DATE_FORMAT_API),
                end_date: moment().format(DATE_FORMAT_API),
                athletes: [],
                squads: [],
                gender: '',
                site: '',
                ergo: '',
                date_of_birth: '',
                first_name: '',
                last_name: '',
                sweep_scull: '',
                weight_class: '',
                weight: null,
                height: null,
                tags: [],
                focuses: []
            };
        }
    },

    actions: {
        setStartDate(context, payload) {
            Vue.set(context.state.filter, 'start_date', payload);
        },

        setEndDate(context, payload) {
            Vue.set(context.state.filter, 'end_date', payload);
        },

        setAthletes(context, payload) {
            Vue.set(context.state.filter, 'athletes', payload);
        },

        setTags(context, payload) {
            Vue.set(context.state.filter, 'tags', payload);
        }
    }
};
